import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Error handler
const handleError = (error) => {
  console.error('API Error:', error);
  if (error.response) {
    throw new Error(error.response.data.detail || 'An error occurred');
  }
  throw new Error('Network error. Please try again.');
};

// ============== Intake Enquiries ==============

export const submitIntakeEnquiry = async (data) => {
  try {
    const response = await apiClient.post('/intake-enquiries', {
      owner_name: data.ownerName,
      email: data.email,
      phone: data.phone || null,
      horse_name: data.horseName,
      horse_age: data.horseAge || null,
      horse_breed: data.horseBreed || null,
      reason: data.reason,
      urgency: data.urgency || null,
      additional_info: data.additionalInfo || null,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ============== Volunteer Applications ==============

export const submitVolunteerApplication = async (data) => {
  try {
    const response = await apiClient.post('/volunteer-applications', {
      name: data.name,
      email: data.email,
      phone: data.phone || null,
      availability: data.availability || null,
      interests: data.interests || null,
      experience: data.experience || null,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ============== Welfare Reports ==============

export const submitWelfareReport = async (data) => {
  try {
    const response = await apiClient.post('/welfare-reports', {
      yard_name: data.yardName,
      location: data.location,
      concern_type: data.concernType,
      description: data.description,
      anonymous: data.anonymous,
      contact_email: data.contactEmail || null,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ============== Contact Messages ==============

export const submitContactMessage = async (data) => {
  try {
    const response = await apiClient.post('/contact', {
      name: data.name,
      email: data.email,
      subject: data.subject,
      message: data.message,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ============== Rehoming Applications ==============

export const submitRehomingApplication = async (data) => {
  try {
    const response = await apiClient.post('/rehoming-applications', {
      applicant_name: data.applicantName,
      email: data.email,
      phone: data.phone,
      address: data.address,
      property_type: data.propertyType,
      experience_level: data.experienceLevel,
      current_horses: data.currentHorses || 0,
      facilities_description: data.facilitiesDescription,
      horse_interest: data.horseInterest || null,
      additional_info: data.additionalInfo || null,
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ============== News Posts ==============

export const getNewsPosts = async (limit = 20) => {
  try {
    const response = await apiClient.get(`/news?limit=${limit}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const getNewsPost = async (slug) => {
  try {
    const response = await apiClient.get(`/news/${slug}`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ============== Site Config ==============

export const getSiteConfig = async () => {
  try {
    const response = await apiClient.get('/config');
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// ============== Health Check ==============

export const healthCheck = async () => {
  try {
    const response = await apiClient.get('/health');
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export default apiClient;
